module.exports = __webpack_public_path__ + "static/media/Portraits-7.02afd765.jpg";